import {Component, Input, ViewChild} from '@angular/core';
import {DialogComponent, ResizeDirections} from "@syncfusion/ej2-angular-popups";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";

@Component({
  selector: 'sb-workflow-modal',
  templateUrl: './workflow-modal.component.html',
  styleUrls: ['./workflow-modal.component.scss']
})
export class WorkflowModalComponent {

  @ViewChild('dialog') ejDialog: DialogComponent;

  public visible = false;

  public position: any = { X: 'center', Y: 'center' };

  public buttons: ButtonPropsModel[] = [
    {
      'click': this.hideDialog.bind(this),
      buttonModel: {
        content: 'Close',
      }
    },
    {
      click: () => (window as any).Navigate.toPopupWindow("!#/WorkflowHistory?query={\"and\":[{\"relationName\":\"WorkflowInstance\",\"operator\":\"=\",\"value\":\"" + this.workflowInstanceID + "\"}]}"),
      buttonModel: {
        content: 'Show history',
        isPrimary: true,
      }
    },
  ];

  @Input()
  title: string = "";

  @Input()
  autoClose: boolean = true;

  workflowInstanceID: string = null;

  minHeight = 600;

  height = window.innerHeight * 0.9;

  width = window.innerWidth * 0.9;

  zIndex = 11; // must be lower than the .cbp-spmenu-vertical modal which is currently 12

  // There three inputs are so we can call methods on the angular component when
  // it is being used as a web component on the Knockout side.
  @Input()
  get ngShowDialog() {
    this.resetDimensions();
    return this.showDialog();
  }

  @Input()
  get ngHideDialog() {
    return this.hideDialog();
  }

  @Input()
  get ngDestroyDialog() {
    return this.destroyDialog();
  }

  constructor() { }

  public closeDialog(args: any) {
    this.visible = false;
    this.resetDimensions();
  }

  public async showDialog() {
    this.ejDialog.show();
    this.visible = true;
  }

  public hideDialog() {
    this.ejDialog.hide();
    this.visible = false;
    this.resetDimensions();
  }

  public destroyDialog() {
    this.ejDialog.destroy();
    this.visible = false;
    this.resetDimensions();
  }

  public onTitle($event) {
    this.title = $event;
  }

  public onWorkflowInstanceID($event) {
    this.workflowInstanceID = $event;
  }

  resetDimensions() {
    const windowHeight = window.innerHeight * 0.9;
    const windowWidth = window.innerWidth * 0.9;

    this.minHeight = 600;
    this.height = Math.max(600, windowHeight);
    this.width = Math.max(900, windowWidth);
  }
}
